import styled from "styled-components";

export const ContinuePlayingButtonWrapperDefaultBox = styled.div`
    margin-top: 1rem;
    width: 25rem;

    @media ${({theme}) => theme.mediaQuery.portrait} {
        width: 100%;
    }
`;